export default __webpack_public_path__ + "static/media/tumblr.22c2bddb.svg";